<template lang="pug">
.order.data.left(:class="{'new-item': isNew}")
  .data-general-information(@click="expand = !expand")
    .item-list
      .data-number-list(:class="{hidden: isNew}") {{ isNew ? 0 : index + 1 }}
      .data-information-list
        .data-title-list.uppercase(:class="{ 'bg-principal': animationCopy }") {{ data.order }}
        .data-description-list.order(v-if="!history")
          .capitalize {{ spanishStatus(data.status) }}
          .capitalize {{ data.name }}
          .capitalize {{ data.location }} - {{ data.department }}
          div {{ data.phones[0] }}
          div {{ dateTime(data.createdAt) }}
          div Valor: {{ money(total) }}
          .dark.color-green(v-if="data.collectedBy") Pagada
        .data-description-list.capitalize(v-else :class="colorTransaction(data.transaction)") {{ data.transaction }}d
          span.lowercase  - {{ dateTime(data.createdAt) }}
        .data-description-list
          .line Al Cobro: {{ data.userPayConveyor ? 'Sí' : 'No' }}{{ ' - ' }}
          .line Contra Entrega: {{ data.cod ? 'Sí' : 'No' }}

  transition.data-details-information(name="slide-fade")
    shForm.list(v-if="expand && !history" :dataOriginal="data" :fillData="true")

  transition.data-details-information(name="slide-fade")
    shHistory(v-if="expand && history" :dataOriginal="data" :color="colorTransaction(data.transaction)")

  .buttons-actions(v-if="data.status === 'created'")
    shActionButton(:action="declineOrder" :params="[data.order]"  text="Declinar" textRunning="Declinando")
    shActionButton(:action="collectOrder" :params="[data.order]"  text="Pagar" textRunning="Pagando")

  .buttons-actions(v-if="data.status === 'paid'")
    shActionButton(:action="returnCollectOrder" :params="[data.order]"  text="Eliminar Pago" textRunning="Eliminando Pago")
</template>

<script>
import shForm from './Form'
import shHistory from './History'
import shExpandButton from '@/components/elements/ExpandButton'
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'
import modals from '@my/store/modals'
import gqlOrderDropshipping from '@/graphql/orderDropshipping'
import gql from '@my/graphql'

export default {
  name: 'Order',

  mixins: [mFilters, mForm],

  components: { shForm, shExpandButton, shHistory },

  props: {
    data: Object,
    index: Number,
    realIndex: Number,
    isNew: Boolean,
    history: Boolean
  },

  data () {
    return {
      expand: false,
      dontSendNotifications: false,
      animationCopy: false
    }
  },

  beforeDestroy () {
    this.expand = false
  },

  methods: {
    spanishStatus (status) {
      const spanishStatus = {
        declined: 'declinada',
        created: 'creada',
        approved: 'aprobada',
        paid: 'pagada',
        packed: 'empacada',
        sent: 'enviada'
      }

      return spanishStatus[status] || status
    },
    name (value) {
      if (!value) return value
      const names = value.split(' ')
      return names[0] || names[1]
    },

    async declineOrder (order) {
      const mutation = gqlOrderDropshipping.DECLINE

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se declinó la orden ${order} correctamente` })
    },

    async approveOrder (order) {
      const mutation = gqlOrderDropshipping.APPROVE

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se aprobó la orden ${order} correctamente` })
    },

    async disapproveOrder (order) {
      const mutation = gqlOrderDropshipping.DISAPPROVE

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se desaprobó la orden ${order} correctamente` })
    },

    async collectOrder (order) {
      const mutation = gqlOrderDropshipping.COLLECT

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se pagó la orden ${order} correctamente` })
    },

    async returnCollectOrder (order) {
      const mutation = gqlOrderDropshipping.RETURN_COLLECT

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se eliminó el pagó de la orden ${order} correctamente` })
    },

    async recoverOrder (order) {
      const mutation = gqlOrderDropshipping.RECOVER

      if (!order) return

      const response = await gql.mutate(mutation, { order })

      if (response) modals.showMessage({ message: `Se recuperó la orden ${order} correntamente` })
    }
  },

  computed: {
    checked: {
      get () {
        if (this.$store.state.data.orders.data.docs[this.realIndex] === undefined) return false
        return this.$store.state.data.orders.data.docs[this.realIndex].checked
      },
      set (value) {
        this.$store.commit('changeCheckItem', { resolver: 'orders', index: this.realIndex, value })
      }
    },
    total () {
      return this.data.total || 0
    },

    quantitySale () {
      return 3
    }
  }
}
</script>

<style lang="stylus">
.data-description-list-image
  height 1.2em

.data-description-list.order
  display inline-flex
  align-items center
  gap 1em
  flex-wrap wrap

.aditional-icons
  display flex
  align-items center
  gap 1.5em

.aditional-checks
  margin-top 2em
</style>



// WEBPACK FOOTER //
// src/components/pages/orderDropshipping/OrderDropshipping.vue